<template>
    <div class="container-fluid">
        <div class="row">
            <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-2">
                    <div class="form-group">
                        <h6>Fecha de la audiencia</h6>
                        <input class="form-control" @change="evtCambioFechaAudiencia" v-model="formulario.fechaAudiencia" type="date">
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-0 pt-2">
                    <div class="form-group">
                        <h6>Hora de la audiencia</h6>
                        <!-- <input class="form-control" v-model="formulario.horaAudiencia" type="time" name="time"> -->
                        <input class="form-control" placeholder="##:##" v-mask="'##:##'" v-model="formulario.horaAudiencia" type="text">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Juez 1</h6>
                    <select @change="evtCambioDeJuez($event)" id="select-juez-gestion" class="form-control">
                        <option :value="-1" selected>Selecciona al juez</option>
                        <option v-for="(juez,index) in jueces" :value="juez.llave" :key="index">{{ juez.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Zoom ID (En caso de aplicar)</h6>
                    <select @change="evtCambioDeZoomId($event)" id="zoom-juez-gestion" class="form-control">
                        <option :value="-1" selected>Selecciona el ID</option>
                        <option v-for="(zoomId,index) in zoom" :value="zoomId.llave" :key="index">{{ zoomId.valor }}</option>
                    </select>  
                </div>
            </div>
            <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Partido judicial</h6>
                    <input class="form-control" v-model="formulario.partidoJudicial" type="text">
                </div>
            </div> -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Partido judicial</h6>
                    <select @change="evtCambioDePartidoJudicialId($event)" class="form-control">
                        <option value="-1" selected>Selecciona el partido judicial</option>
                        <option v-for="(partidoJudicial,index) in partidosJudiciales" :value="partidoJudicial.llave" :key="index">{{ partidoJudicial.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Tipo de carpeta</h6>
                    <div class="seccion-tipos-carpeta">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="radioCD" id="radio-cd-id" @click="evtCambioSeleccionTipoCarpeta({ idRadio: 'radio-cd-id', valor: 1 })">
                            <label class="form-check-label" for="radioCD">
                                CD
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="radioCA" id="radio-ca-id" @click="evtCambioSeleccionTipoCarpeta({ idRadio: 'radio-ca-id', valor: 2 })">
                            <label class="form-check-label" for="radioCA">
                                CA
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="radioCJ" id="radio-cj-id" @click="evtCambioSeleccionTipoCarpeta({ idRadio: 'radio-cj-id', valor: 5 })">
                            <label class="form-check-label" for="radioCJ">
                                CJ
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-2">
                    <div class="form-group">
                        <h6>Carpeta</h6>
                        <input class="form-control" placeholder="####" v-mask="'####'" v-model="formulario.carpeta" type="text">
                    </div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-0 pt-2">
                    <div class="form-group">
                        <h6>Carpeta Año</h6>
                        <input class="form-control" placeholder="####" v-mask="'####'" v-model="formulario.carpetaA" type="text">
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Tipo Audiencia</h6>
                    <select @change="evtCambioDeTipoAudiencia($event)" class="form-control">
                        <option value="-1" selected>Selecciona el tipo de audiencia</option>
                        <option v-for="(tipoAudiencia,index) in tiposAudiencia" :value="tipoAudiencia.llave" :key="index">{{ tipoAudiencia.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Detenido</h6>
                    <select @change="evtCambioDeDetenido($event)" class="form-control">
                        <option value="-1" selected>Detenido</option>
                        <option v-for="(detenido,index) in detenidos" :value="detenido.llave" :key="index">{{ detenido.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <hr/>
            </div>
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Juez 2</h6>
                    <select @change="evtCambioDeJuezDos($event)" class="form-control">
                        <option :value="-1" selected>Selecciona al juez</option>
                        <option v-for="(juez,index) in jueces" :value="juez.llave" :key="index">{{ juez.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Juez 3</h6>
                    <select @change="evtCambioDeJuezTres($event)" class="form-control">
                        <option :value="-1" selected>Selecciona al juez</option>
                        <option v-for="(juez,index) in jueces" :value="juez.llave" :key="index">{{ juez.valor }}</option>
                    </select>  
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group">
                    <h6>Audiencia</h6>
                    <select @change="evtCambioDeAudiencia($event)" class="form-control">
                        <option v-for="(aud,index) in audiencias" :value="aud.llave" :key="index">{{ aud.valor }}</option>
                    </select>  
                    <input v-show="formulario.audiencia == 0" placeholder="Nombre del evento" class="form-control mt-1" v-model="formulario.nombreEvento" type="text">
                </div>
            </div>
            <div v-show="formulario.audiencia == 0" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2 pt-2">
                <div class="form-group">
                    <h6>Fecha Término del Evento</h6>
                    <input class="form-control" v-model="formulario.fechaTerminoEvento" type="date">
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="form-group d-flex justify-content-end">
                    <button type="button" @click="evtGetDatosFormulario({ desdeComponentePadre: false })" class="btn btn-sm btn-info">
                        <i class="fas fa-save"></i>&nbsp;&nbsp;Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import VueMask from 'v-mask'
import { campoEsValido } from "../../../SINOJ/Comun/Funciones/validaciones.js"
import comun from "@/../static/js/comun"

Vue.use(VueMask);
export default {
    props: {
        idElemento: {
            type: String,
            default: 'id-c-formulario'
        },
        esParaEdicion: {
            type: Boolean,
            default: false
        },
        formularioDatosPadre: {
            type: Object,
            default: () => ({ 
            })
        },
        jueces: {
            type: Array,
            default: () => []
        },
        zoom: {
            type: Array,
            default: () => []
        },
        tiposAudiencia: {
            type: Array,
            default: () => []
        },
        detenidos: {
            type: Array,
            default: () => []
        },
        partidosJudiciales: {
            type: Array,
            default: () => []
        },
        audiencias: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            moment,
            formulario: {
                fechaAudiencia: null,
                juez: null,
                zoomId: null,
                partidoJudicial: null,
                horaAudiencia: null,
                tipoDeCarpeta: null,
                carpeta: null,
                carpetaA: null,
                tipoAudienciaId: null,
                detenidoId: null,
                fechaAudienciaConHora: null,
                juezDos: null,
                juezTres: null,
                audiencia: 1,
                nombreEvento: null,
                fechaTerminoEvento: null
            }
        }
    },
    methods: {
        evtCambioDeAudiencia: function(evento) {
            this.formulario.audiencia = (evento.target.value != -1 && evento.target.value != '-1') ? evento.target.value : null;
            if(this.formulario.audiencia > 0) {
                this.formulario.nombreEvento = null;
                this.formulario.fechaTerminoEvento = null;
               /*  this.formulario.tipoDeCarpeta = null; */
            }
        },
        evtCambioDeJuezDos: function(evento) {
            this.formulario.juezDos = evento.target.value;
        },
        evtCambioDeJuezTres: function(evento) {
            this.formulario.juezTres = evento.target.value;
        },
        evtCambioFechaAudiencia: function(evento) {
            this.$emit('actualizarAgenda', { fecha: evento.target.value, juez: this.formulario.juez != -1 ? this.formulario.juez : null })
        },
        evtCambioSeleccionTipoCarpeta: function({ idRadio, valor }) {
            this.$nextTick(() => {
                this.formulario.tipoDeCarpeta = valor;
                $(".seccion-tipos-carpeta"+ " input[type='radio']").prop('checked', false);
                $("#" + idRadio).prop('checked', true);
            });
        },
        evtCambioDeJuez: function(evento) {
            this.formulario.juez = evento.target.value;
            if(this.formulario.fechaAudiencia != null && this.formulario.fechaAudiencia != undefined) {
                this.$emit('actualizarAgenda', { fecha: this.formulario.fechaAudiencia, juez: this.formulario.juez != -1 ? this.formulario.juez : null})
            }
        },
        evtCambioDeZoomId: function(evento) {
            this.formulario.zoomId = evento.target.value;
        },
        evtCambioDeTipoAudiencia: function(evento) { debugger
            this.formulario.tipoAudienciaId = evento.target.value;
            if(this.formulario.tipoAudienciaId == 'Sesión de Mediación') {
                this.formulario.juez = null;
                this.formulario.zoomId = null;
                $("#select-juez-gestion").val(-1);
                $("#zoom-juez-gestion").val(-1);
            }
        },
        evtCambioDePartidoJudicialId: function(evento) {
            this.formulario.partidoJudicial = evento.target.value;
        },
        evtCambioDeDetenido: function(evento) {
            this.formulario.detenidoId = evento.target.value;
        },
        evtGetDatosFormulario: function({ desdeComponentePadre }) { debugger
            let fecha = moment(this.formulario.fechaAudiencia).format('YYYY-MM-DD');
            let dateTime = campoEsValido({ campoAValidar: this.formulario.horaAudiencia }) ? `${fecha} ${this.formulario.horaAudiencia}` : `${fecha}` ;
            this.formulario.fechaAudienciaConHora = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
            if(!desdeComponentePadre) {
                if(this.tieneTodosLosCamposObligatorios()) {
                    if(campoEsValido({ campoAValidar: this.formulario.horaAudiencia })) {
                        if(this.horaValida(this.formulario.horaAudiencia)) {
                            this.$emit('GetDatosFormulario', this.formulario);
                        }
                    }
                    else {
                        this.$emit('GetDatosFormulario', this.formulario);
                    }
                }
            }
        },
        tieneTodosLosCamposObligatorios: function() { debugger
            let todosLosCamposLLenos = true;
            const { fechaAudiencia, juez, partidoJudicial, tipoDeCarpeta, carpeta, carpetaA, detenidoId } = this.formulario;
            let camposObligatorios = [
                { valor: fechaAudiencia, msjError: 'Debes ingresar una fecha de audiencia valida' },
                /* { valor: juez, msjError: 'Debes ingresar un juez 1 valido' }, */
                { valor: partidoJudicial, msjError: 'Debes ingresar un partido judicial valido' }
            ];

            if(this.formulario.tipoAudienciaId != 'Sesión de Mediación') {
                camposObligatorios.push({ valor: juez, msjError: 'Debes ingresar un juez 1 valido' });
            }

            if(this.formulario.audiencia == 1) {
                camposObligatorios.push({ valor: tipoDeCarpeta, msjError: 'Debes ingresar un tipo de carpeta valido' },);
                camposObligatorios.push({ valor: carpeta, msjError: 'Debes ingresar una carpeta valida' },);
                camposObligatorios.push({ valor: carpetaA, msjError: 'Debes ingresar un año de carpeta valido' },);
                camposObligatorios.push({ valor: detenidoId, msjError: 'Debes ingresar un valor tipo detenido valido' });
            }
            for(let i=0; i<camposObligatorios.length; i++) {
                let campo = camposObligatorios[i];
                if(!campoEsValido({ campoAValidar: campo.valor }) || campo.valor == -1 || campo.valor == '-1') {
                    todosLosCamposLLenos = false;
                    comun.mensajeDeAlerta(campo.msjError);
                    break;
                }
            }
            return todosLosCamposLLenos;
        },
        horaValida: function(horaStr) { debugger
            let elementoHora = horaStr.split(':');
            if(campoEsValido({ campoAValidar: elementoHora })) {
                let hora = elementoHora[0];
                let minutos = elementoHora[1];
                if(!campoEsValido({ campoAValidar: hora }) || !campoEsValido({ campoAValidar: minutos })) {
                    comun.mensajeDeAlerta('Debes ingresar un valor para hora y minuto [##:##], ejemplo: manera correcta = 15:30, manera incorrecta = 15:3');
                    return false;
                }
                if(campoEsValido({ campoAValidar: hora }) && hora.length < 2) {
                    comun.mensajeDeAlerta('Debes ingresar el valor de la hora con el siguiente formato [##], ejemplo: manera correcta = 05, manera incorrecta = 5');
                    return false;
                }
                if(campoEsValido({ campoAValidar: hora }) && parseInt(hora) >= 24) {
                    comun.mensajeDeAlerta('Debes ingresar un valor entre el rango 00 - 24 para el valor de la hora');
                    return false;
                }
                if(campoEsValido({ campoAValidar: minutos }) && minutos.length < 2) {
                    comun.mensajeDeAlerta('Debes ingresar el valor de los minutos con el siguiente formato [##], ejemplo: manera correcta = 05, manera incorrecta = 5');
                    return false;
                }
                if(campoEsValido({ campoAValidar: minutos }) && parseInt(minutos) >= 60) {
                    comun.mensajeDeAlerta('Debes ingresar un valor entre el rango 00 - 59 para el valor de los minutos');
                    return false;
                }
            }
            return true;
        }
    }
}
</script>
<style scoped>
.seccion-tipos-carpeta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6em;
    flex-wrap: wrap;
}

.seccion-tipos-carpeta {
    background-color: rgb(83, 83, 83);
    border-radius: 4px;
    padding: 1em 1em 1em 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/Audiencias/Programacion/Comun/CFormularioProgramacionAudiencia.vue